(function () {
  function slugify(text) {
    return text
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[\s+~\/]/g, "-")
      .replace(/[().,!?'"“”’]/g, "")
      .replace(/-+/g, "-");
  }

  function uniqueId(base, used) {
    let id = base;
    let i = 2;
    while (used.has(id)) {
      id = `${base}-${i}`;
      i++;
    }
    used.add(id);
    return id;
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Alleen op artikelpagina’s (blog posts)
    // Dawn gebruikt vaak templates als "article"
    // Deze check is bewust mild: als #ArticleContent niet bestaat doen we niets.
    const content = document.getElementById("ArticleContent");
    if (!content) return;

    const headings = Array.from(content.querySelectorAll("h2"));
    if (headings.length < 2) return; // optioneel: toon alleen TOC bij 2+ H2's

    // Verzamel al gebruikte id’s in de content
    const usedIds = new Set(
      Array.from(content.querySelectorAll("[id]"))
        .map((el) => el.id)
        .filter(Boolean)
    );

    // Bouw TOC wrapper
    const toc = document.createElement("nav");
    toc.className = "article-toc";
    toc.setAttribute("aria-label", "Inhoudsopgave");

    const title = document.createElement("p");
    title.className = "article-toc__title";
    title.textContent = "Inhoudsopgave";
    toc.appendChild(title);

    const list = document.createElement("ul");
    list.className = "article-toc__list";

    headings.forEach((h2) => {
      const text = (h2.textContent || "").trim();
      if (!text) return;

      // Geef H2 een id als die er nog niet is
      if (!h2.id) {
        const base = slugify(text) || "sectie";
        h2.id = uniqueId(base, usedIds);
      } else {
        usedIds.add(h2.id);
      }

      const li = document.createElement("li");
      li.className = "article-toc__item";

      const a = document.createElement("a");
      a.className = "article-toc__link";
      a.href = `#${h2.id}`;
      a.textContent = text;

      // Optioneel: soepel scrollen (en rekening houden met sticky header)
      a.addEventListener("click", function (e) {
        const target = document.getElementById(h2.id);
        if (!target) return;
        e.preventDefault();

        const header = document.querySelector(".header-wrapper, sticky-header");
        const headerHeight = header ? header.getBoundingClientRect().height : 0;

        const y = window.scrollY + target.getBoundingClientRect().top - headerHeight - 12;
        window.scrollTo({ top: y, behavior: "smooth" });

        history.replaceState(null, "", `#${h2.id}`);
      });

      li.appendChild(a);
      list.appendChild(li);
    });

    toc.appendChild(list);

    // Plaats TOC vóór de eerste H2 (binnen de article content)
    const firstH2 = headings[0];
    firstH2.parentNode.insertBefore(toc, firstH2);
  });
})();
